import React, { useState } from "react";
import "./LearningJourney.css";
import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabsUnstyled from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "./APIautomationLearningJourney.css";

import useFetchImageUrls from "../../ConstantUseFetchImageUrls";
import { apiAutomationPageImages } from "../../imagesData/ImagesData";

const APIautomationLearningJourney = () => {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const query = `params=${encodeURIComponent(
    JSON.stringify(apiAutomationPageImages)
  )}`;
  const { imageUrls, error } = useFetchImageUrls(query);
  if (error) return <div>Error loading images.</div>;
  return (
    <>
      <div className="learning-Journey-container">
        <h2>API Automation Learning Journey</h2>
        <div className="lj-menu-wrapper">
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box>
                <TabList
                  role="tablist"
                  onChange={handleChange}
                  className="main-list"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label="Overall"
                    value="1"
                    className="list1 item"
                    role="tab"
                  />
                  <Tab
                    label="Aware"
                    value="2"
                    className="list2 item"
                    role="tab"
                  />
                  <Tab
                    label="Equipped"
                    value="3"
                    className="list3 item"
                    role="tab"
                  />
                  <Tab
                    label="Competent"
                    value="4"
                    className="list4 item"
                    role="tab"
                  />
                  {/* <Tab label="Expert" value="5" className='list5 item'/> */}
                </TabList>
              </Box>
              <div className="lj-box">
                <TabPanel value="1" role="tabpanel">
                  <div className="lj-images">
                    <a
                      href="javascript:void(0)"
                    >
                      <img
                        src={imageUrls?.imageUrl?.img2}
                        alt="overall-img"
                        className="lj-images"
                      />
                    </a>
                  </div>
                </TabPanel>
                <TabPanel value="2" role="tabpanel">
                  <div className="LJ-link-Wrapp">
                    {/* <img src='images/APIautomation/LearningJourney/Aware/APITesting-AWARE-BG.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='APIAware'>
                    <p className='link1'>
                      <a href="https://accenture.percipio.com/courses/c9614755-e978-4ed0-8706-381cbc3969cc/videos/dfcd036a-2e02-4ac2-8734-88a777f226e7" target="_blank"><img src='images/APIautomation/LearningJourney/Aware/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://www.pluralsight.com/courses/java-web-api-test-automation-getting-started" target="_blank"><img src='images/APIautomation/LearningJourney/Aware/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/courses/7ce10fe0-e47d-4d9c-a581-038a8e039256/videos/3816f533-80b2-4940-844f-b27794bccfbd" target="_blank"><img src='images/APIautomation/LearningJourney/Aware/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/courses/2e2c26f8-1958-4c25-99e3-8acc49f5d8de/videos/c244a6b9-e403-4136-8a8b-3ad409ae6046" target="_blank"><img src='images/APIautomation/LearningJourney/Aware/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://www.pluralsight.com/courses/five-essential-tools-building-rest-api" target="_blank"><img src='images/APIautomation/LearningJourney/Aware/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/courses/b3858d2b-3a10-4448-993d-814d870ff450/videos/4564f607-9ea9-4952-bd49-12a1b1c26622" target="_blank"><img src='images/APIautomation/LearningJourney/Aware/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="accenture.percipio.com/courses/1f25bee1-8662-4e55-94d1-95b691512c6e/videos/16d7a540-ecfb-41c2-9206-08569a3426cd" target="_blank"><img src='images/APIautomation/LearningJourney/Aware/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://accenture.percipio.com/courses/115249b8-3703-49f1-8c30-f55389ce9253/videos/16075f9a-1239-47df-8cc2-7d7ad33eb274" target="_blank"><img src='images/APIautomation/LearningJourney/Aware/8.png'/></a>
                    </p>
                  </div>
                  </div> */}
                    <a
                      href="https://wd103.myworkday.com/accenture/learning/program/449ea08586631001fe6ac7f51d1f0000?type=2d29754fdb8e100008b50ff6bc94003b"
                      target="_blank"
                    >
                      <img
                        src={imageUrls?.imageUrl?.img3}
                        alt="Aware-img"
                        className="lj-images"
                      />
                    </a>
                  </div>
                </TabPanel>
                <TabPanel value="3" role="tabpanel">
                  <div className="LJ-link-Wrapp">
                    {/* <img src='images/APIautomation/LearningJourney/Equipped/APITesting-Equipped-BG.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='APIEquipped'>
                    <p className='link1'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_2c8119b3" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_93q67vly" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="mediaexchange.accenture.com/media/t/1_0gr8e42f" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_enoavoq7" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_w3mseyd7" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="mediaexchange.accenture.com/media/t/1_jcwb4foz" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_tlk65o9r" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_ekq0qipr" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="mediaexchange.accenture.com/media/t/1_elrz2zo2" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_922mzntf" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_ju9q097m" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_lfegucww" target="_blank"><img src='images/APIautomation/LearningJourney/Equipped/12.png'/></a>
                    </p>
                    <p className='link13'>
                      <a><img src='images/APIautomation/LearningJourney/Equipped/13.png'/></a>
                    </p>
                  </div>
                  </div> */}
                    <a
                      href="https://wd103.myworkday.com/accenture/learning/course/86dc5c1755721001fb51710b20ca0000?type=9882927d138b100019b928e75843018d"
                      target="_blank"
                    >
                      <img
                        src={imageUrls?.imageUrl?.img4}
                        alt="Equipped-img"
                        className="lj-images"
                      />
                    </a>
                  </div>
                </TabPanel>
                <TabPanel value="4" role="tabpanel">
                  <div className="LJ-link-Wrapp">
                    {/* <img src='images/APIautomation/LearningJourney/Competent/APITesting-Competent-BG.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='APICompetent'>
                    <p className='link1'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_2c8119b3" target="_blank"><img src='images/APIautomation/LearningJourney/Competent/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_wzjd7cws" target="_blank"><img src='images/APIautomation/LearningJourney/Competent/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_tyltbsds" target="_blank"><img src='images/APIautomation/LearningJourney/Competent/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_blgenc5e" target="_blank"><img src='images/APIautomation/LearningJourney/Competent/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_ty9m8k01" target="_blank"><img src='images/APIautomation/LearningJourney/Competent/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_jy23llu0" target="_blank"><img src='images/APIautomation/LearningJourney/Competent/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_av84m5bk" target="_blank"><img src='images/APIautomation/LearningJourney/Competent/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a ><img src='images/APIautomation/LearningJourney/Competent/8.png'/></a>
                    </p>
                  </div>
                  </div> */}
                    <a
                      href="https://wd103.myworkday.com/accenture/learning/course/9eff1123a8d71001fa6dfc1c28c50000?type=9882927d138b100019b928e75843018d"
                      target="_blank"
                    >
                      <img
                        src={imageUrls?.imageUrl?.img5}
                        alt="Competent-img"
                        className="lj-images"
                      />
                    </a>
                  </div>
                </TabPanel>
              </div>
            </TabContext>
          </Box>
        </div>
      </div>
    </>
  );
};
export default APIautomationLearningJourney;
